import { ReactElement } from 'react';
import { createProfitArray, interestGraphOptions } from '../utils';
import InterestGraphBase from './InterestGraphBase';

const profitData = createProfitArray(7, 50, 20, 50, false);
const textPath = {
  title: 'course2.part3.interest_example_graph_2.title',
  subtitle: 'course2.part3.interest_example_graph_2.subtitle',
  altText: 'course2.part3.interest_example_graph_2.alt_text',
  estimatedSave: 'course2.part3.interest_example_graph_2.estimated_save',
};
const specs = {
  investmentAmount: 50,
  accountSavings: undefined,
  profitExpected: 7,
  investmentTime: 20,
};

const InterestGraph2 = (): ReactElement => {
  const options = interestGraphOptions(profitData);
  return <InterestGraphBase options={options} text={textPath} specs={specs} />;
};

export default InterestGraph2;
